interface ComparisonItem {
  before: string;
  after: string;
}

interface AppleSplitComparisonProps {
  items: ComparisonItem[];
}

const AppleSplitComparison = ({ items }: AppleSplitComparisonProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-0 min-h-[400px] md:min-h-[600px]">
      {/* Left Side - Before */}
      <div className="bg-gray-100 dark:bg-gray-900 flex flex-col items-center justify-center p-8 sm:p-12 md:p-16 space-y-12 md:space-y-24">
        <h3 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-gray-600 dark:text-gray-400 mb-6 md:mb-12">
          Antes
        </h3>
        {items.map((item, index) => (
          <div key={index} className="text-center max-w-sm">
            <p className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-700 dark:text-gray-300 leading-tight">
              {item.before}
            </p>
          </div>
        ))}
      </div>

      {/* Right Side - After */}
      <div className="bg-white dark:bg-black flex flex-col items-center justify-center p-8 sm:p-12 md:p-16 space-y-12 md:space-y-24 shadow-[-20px_0_60px_-15px_rgba(0,0,0,0.1)]">
        <h3 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-black dark:text-white mb-6 md:mb-12">
          Ahora
        </h3>
        {items.map((item, index) => (
          <div key={index} className="text-center max-w-sm">
            <p className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-black dark:text-white leading-tight">
              {item.after}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AppleSplitComparison;
